/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Display_WelcomeInputs */

const vi_customer_display_welcome = /** @type {(inputs: Customer_Display_WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cảm ơn quý khách!`)
};

/**

* @param {Customer_Display_WelcomeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_display_welcome = /** @type {((inputs?: Customer_Display_WelcomeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Display_WelcomeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_display_welcome(inputs)
});